import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FH140 / FH141)
// ============================================================

export interface FH141 {
  fh141_01: string;    // 折讓單號（FK→FH140_01）
  fh141_02: number;    // 明細序號
  fh141_11: string;    // 入庫單號
  fh141_12: string;    // 公司代號（同步自單頭）
  fh141_13: number;    // 折讓淨額
  fh141_14: number;    // 稅額
  fh141_15: number;    // SEL-NO（入庫項次）
  fh141_16: string;    // 幣別
  fh141_17: number;    // 折讓金額（淨額+稅額）
  fh141_18: string;    // 備用（客訴單號）
  fh141_19: number;    // 入庫類型（1=委外託工, 2=繳庫）
  fh141_90: number;    // 版本號
}

export interface FH140 {
  fh140_01: string;          // 折讓單號
  fh140_11: string | null;   // 折讓日期
  fh140_12: string;          // 公司代號
  fh140_13: string;          // 公司名稱
  fh140_14: number;          // 折讓淨額合計
  fh140_15: number;          // 折讓稅額合計
  fh140_16: string;          // 幣別
  fh140_17: string;          // 備用
  fh140_18: number;          // 總項數
  fh140_19: string;          // 備注
  fh140_80: string;          // 狀態（N=正常）
  fh140_89: string;          // 部門代碼
  fh140_90: number;          // 版本號
  fh140_91: string;          // 修改人
  fh140_92: string | null;   // 修改時間
  fh140_93: string;          // 建立人
  details?: FH141[];
}

export interface ListResponse {
  data: FH140[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/pwh204';

export const pwh204Api = {
  list: async (page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(BASE, { params: { page, pageSize: size } });
    return res.data;
  },

  get: async (id: string): Promise<FH140> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  create: async (master: Partial<FH140>, details: Partial<FH141>[]): Promise<FH140> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (id: string, master: Partial<FH140>, details: Partial<FH141>[]): Promise<FH140> => {
    const res = await apiClient.put(`${BASE}/${id}`, { master, details });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },
};

export default pwh204Api;
